import angular from 'angular';
import swal from 'sweetalert';

class NapomenaEditController {
    constructor(Model) {
        this.Model = Model;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        console.log(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            swal("", "Podaci su uspiješno pohranjeni", "success");
            this.onSubmit({model: data});
        });
    }

    cancel() {
        if (this.form.$pristine) {
            this.onCancel();
            return;
        }
        swal({
            title: "Jeste li sigurni?",
            text: "Podaci nisu spremljeni. Želite li zatvoriti formu za unos?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Da, zatvori!",
            cancelButtonText: 'Odustani',
            closeOnConfirm: true
        },
        () => this.onCancel());
    }

    getFields(){
        return {
            napomena: {
                key: 'napomena',
                type: 'hTextarea',
                templateOptions: {
                    label: 'Napomena',
                    rows: 10,
                }
            }
        };
    };
}

NapomenaEditController.$inject = ['Pacijent'];

export  {NapomenaEditController};



// WEBPACK FOOTER //
// ./app/components/pacijent/form/napomena.controller.js